import AOS from 'aos';
import 'aos/dist/aos.css';

export function initAOS() {
let isAnchorNavigation = false;
    
AOS.init({
    duration: 1200,
    once: true,
    disable: function() {
        // Disable on mobile or during anchor navigation
        return
        //window.innerWidth < 768 ||
        isAnchorNavigation;
    }
});
    
// Only intercept clicks inside the anchor-block nav to suppress AOS re-triggering during scroll.
// All other #hash links are handled natively by scroll-behavior:smooth + scroll-margin-top in CSS.
document.querySelectorAll('[data-anchor-nav] a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function(e) {
            const targetId = this.getAttribute('href');

            // Skip if it's just "#" or empty
            if (!targetId || targetId === '#') return;

            const targetElement = document.querySelector(targetId);

            if (targetElement) {
                // Set flag to disable animations
                isAnchorNavigation = true;

                // Remove AOS attributes temporarily to prevent animation
                const aosElements = document.querySelectorAll('[data-aos]');
                aosElements.forEach(el => {
                    el.setAttribute('data-aos-temp', el.getAttribute('data-aos'));
                    el.removeAttribute('data-aos');
                    el.classList.add('aos-animate'); // Force visible state
                });

                // Re-enable animations after scroll completes
                setTimeout(() => {
                    isAnchorNavigation = false;

                    // Restore AOS attributes
                    aosElements.forEach(el => {
                        const tempAos = el.getAttribute('data-aos-temp');
                        if (tempAos) {
                            el.setAttribute('data-aos', tempAos);
                            el.removeAttribute('data-aos-temp');
                        }
                    });

                    AOS.refresh();
                }, 1000);
            }
        });
    });
}
